import { createSelector } from 'reselect';

export const casesStoreSelector = state => state.get('cases');

export const newCaseNumberSelector = createSelector(casesStoreSelector, store =>
  store.get('newCaseNumber'),
);



// WEBPACK FOOTER //
// ./src/redux/cases/selectors.js